export const SNOOZE_MODES = {
  THREE_MONTHS: "3_months",
  SIX_MONTHS: "6_months",
  TWELVE_MONTHS: "12_months",
  FOREVER: "forever",
  UNSNOOZE: "unsnooze",
};

export function getSnoozeMode(credit, now = new Date()) {
  if (credit?.stats?.snoozed_forever) {
    return SNOOZE_MODES.FOREVER;
  }

  if (credit?.stats?.snoozed_until) {
    const snoozedUntil = new Date(credit.stats.snoozed_until);

    if (snoozedUntil > now) {
      return "until";
    }
  }

  return null;
}

export function isSnoozedNow(credit, now = new Date()) {
  return getSnoozeMode(credit, now) !== null;
}

export function buildSnoozePayload(mode, now = new Date()) {
  const addMonths = (months) => {
    const date = new Date(now);
    date.setMonth(date.getMonth() + months);
    return date.toISOString();
  };

  if (mode === SNOOZE_MODES.THREE_MONTHS) {
    return {
      snoozed_until: addMonths(3),
      snoozed_forever: false,
    };
  }

  if (mode === SNOOZE_MODES.SIX_MONTHS) {
    return {
      snoozed_until: addMonths(6),
      snoozed_forever: false,
    };
  }

  if (mode === SNOOZE_MODES.TWELVE_MONTHS) {
    return {
      snoozed_until: addMonths(12),
      snoozed_forever: false,
    };
  }

  if (mode === SNOOZE_MODES.FOREVER) {
    return {
      snoozed_until: null,
      snoozed_forever: true,
    };
  }
   if (mode === SNOOZE_MODES.UNSNOOZE) {
    return {
      snoozed_until: null,
      snoozed_forever: false,
    };
  }

  return {
    snoozed_until: null,
    snoozed_forever: false,
  };
}

export function getAvailableSnoozeMenuOptions(credit, now = new Date()) {
  if (isSnoozedNow(credit, now)) {
    return [
      {
        mode: SNOOZE_MODES.UNSNOOZE,
        label: "Einblenden",
      },
    ];
  }

  return [
    {
      mode: SNOOZE_MODES.THREE_MONTHS,
      label: "Ausblenden für 3 Monate",
    },
    {
      mode: SNOOZE_MODES.SIX_MONTHS,
      label: "Ausblenden für 6 Monate",
    },
    {
      mode: SNOOZE_MODES.TWELVE_MONTHS,
      label: "Ausblenden für 12 Monate",
    },
    {
      mode: SNOOZE_MODES.FOREVER,
      label: "Immer ausblenden",
    },
  ];
}